<template>
    <div>
        <v-container grid-list-xs>
            <v-sheet class="pa-5" elevation="3">
                <v-row class="py-0">
                    <v-col class="py-0">
                        <iframe
                            id="aff-iframe"
                            title="aff-iframe-esign"
                            class="iframe-container"
                            :src="iframeUrl"
                            type="text/html"
                            width="100%"
                            @error="handleError"
                        ></iframe>
                    </v-col>
                </v-row>

                <div class="py-6 card-actions">
                    <BackButton class="summary-button card-actions-back" rounded outlined color="primary" @click="back">
                        {{ $t("action.back") }}
                    </BackButton>
                </div>
            </v-sheet>
        </v-container>
        <GeneratingAgreementModal :show="showGeneratingAgreementModal" />
    </div>
</template>

<script>
    import { sessionState } from "@/state"
    import { applyService, logService } from "@/service"
    import GeneratingAgreementModal from "@/components/modal/GeneratingAgreementModal.vue"
    import ApplyResponseCode from "@/model/apply/ApplyResponseCode"

    export default {
        components: {
            GeneratingAgreementModal,
        },
        data() {
            return {
                iframeUrl: "",
                showGeneratingAgreementModal: false,
                isSigned: false,
                submitting: false,
            }
        },
        mounted() {
            window.addEventListener("message", this.receiveMessage)
            this.getIframeUrl()
        },
        destroyed() {
            window.removeEventListener("message", this.receiveMessage)
        },
        methods: {
            // Does not look like errors are being caught
            // Could be issue with receiving url response but the response itself is not loading leaving the screen blank
            async getIframeUrl() {
                this.showGeneratingAgreementModal = true
                try {
                    const response = await applyService.getIframeUrl(sessionState.providerKey)
                    this.iframeUrl = response.url
                    // iframeUrl comes back undefined possibly add check for !this.iframeUrl as well
                    if (response.status === ApplyResponseCode.ERROR) {
                        await this.$router.push(`/providers/${sessionState.providerKey}/error`)
                    }
                } catch (e) {
                    console.error("AFF Get Iframe Error", e)
                    logService.error("AFF Get Iframe Error: " + JSON.stringify(e))
                } finally {
                    this.showGeneratingAgreementModal = false
                }

                if (this.iframeUrl === null) {
                    logService.info(`AFF Iframe url is null redirecting to error page`)
                    await this.$router.push(`/providers/${sessionState.providerKey}/error`)
                }
            },

            back() {
                this.$router.push(`/providers/${sessionState.providerKey}/approved`)
            },

            handleError(err) {
                console.error("AFF Iframe Error", err)
                logService.error("AFF Iframe Error: ", err)
            },

            async receiveMessage(message) {
                if (message.data?.event === `aff-signing-complete`) {
                    logService.info(`Received javascript callback event: ${message.data?.source}`)
                    this.isSigned = true
                    this.submitting = true
                    await this.$router.push(`/providers/${sessionState.providerKey}/completeApplicationSubmit`)
                }
            },

            async complete() {
                if (this.isSigned) {
                    this.submitting = true
                    await this.$router.push(`/providers/${sessionState.providerKey}/completeApplicationSubmit`)
                }
                this.submitting = false
            },
        },
    }
</script>

<style lang="scss" scoped>
    .iframe-container {
        height: 60vh;
        overflow-y: hidden;
    }

    .submit-button {
        height: fit-content !important;
        white-space: normal;
        display: block;

        @media #{map-get($display-breakpoints, "sm-and-up")} {
            display: inline-flex;
            white-space: nowrap;
            width: auto;
            max-width: fit-content;
            height: auto;
        }
    }
</style>
